import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { ToastrServiceLocal } from '../../services/toast/toastr.service';
import { DataApiService } from '../../services/data-api.service';
import { tap } from 'rxjs/operators';
import { MensajesHttpService } from '../../utils/mensajesHttp/mensajes-http.service';
import { DataApi } from 'src/app/Model/dataApi';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators/catchError';
import { BehaviorSubject, EMPTY, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { productInterface } from 'src/app/Model/Shopping/shopping.interface';
import { DetalleArregloPagoInterface, PagoMoraInterface } from 'src/app/Model/Afiliados/estadoAfiliado';
import { DatosGeneralesFacadeService } from 'src/app/services/utils/datos-generales-facade.service';

@Injectable({
    providedIn: 'root'
})
export class AfiliadosService {
    public cargando: boolean = false;
    public cargandoE: boolean = false;
    public cargandoDetallePago: boolean = false;
    public cargandoP: boolean = false;
    public cargandoR: boolean = false;
    public cargandoF: boolean = false;
    public cargandoPrint: boolean = false;
    public cargandoExpediente: boolean = false;

    private Cargando$ = new BehaviorSubject<boolean>(false);
    public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

    private Productos$ = new BehaviorSubject<productInterface[]>([]);
    public responseProductos$: Observable<productInterface[]> = this.Productos$.asObservable();

    private Parentesco$ = new BehaviorSubject<any>({});
    public responseParentesco$: Observable<any> = this.Parentesco$.asObservable();

    private ProductosDetalles$ = new BehaviorSubject<any>({});
    public responseProductosDetalles$: Observable<any> = this.ProductosDetalles$.asObservable();

    private PagoMora$ = new BehaviorSubject<PagoMoraInterface[]>([]);
    public responsePagoMora$: Observable<PagoMoraInterface[]> = this.PagoMora$.asObservable();

    private CargandoCuentasContable$ = new BehaviorSubject<boolean>(false);
    public responseCargandoCuentasContable$: Observable<boolean> = this.CargandoCuentasContable$.asObservable();

    public suscripciones: Subscription = new Subscription();


    constructor(private router: Router, private _dataApi: DataApiService, private _toast: ToastrServiceLocal, public _mensajesHttp: MensajesHttpService, public datosGeneralesFacade: DatosGeneralesFacadeService) { }
    //MOSTRAS CLINICAS
    mostrasClinicas(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/clinicas`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA CLINICA
    crearClinica(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Clinicas`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la clinica', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ACTUALIZAR CLINICA
    editarClinica(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Clinicas`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar la clinica', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //ELIMINAR CLINICA
    eliminarClinica(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/Clinicas/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    mostrarGenerales(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/registro/generales`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS conceptos
    mostrasConceptos(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las conceptospago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrasConceptosPagoAfiliado(idAfiliado: any, callback) {
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los conceptos de pago del afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    // NUEVA CONCEPTO
    crearConcepto(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la conceptospago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ACTUALIZAR CONCEPTO
    editarConcepto(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar la conceptospago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //ELIMINAR Concepto
    eliminarConcepto(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar conceptospago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS AFILIADOS
    mostrasAfiliados(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/datosafiliado`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los afiliados', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS ESTADOS
    mostrasEstados(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/estadoafiliacion`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las estado filiacion', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA ESTADO
    crearEstado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/estadoafiliacion`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la estado afiliacion', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ACTUALIZAR ESTADO
    editarEstado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/estadoafiliacion`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar la estado afiliacion', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //ELIMINAR ESTADO
    eliminarEstado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/estadoafiliacion/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar estado afiliacion', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }





    //MOSTRAS FRECUENCIAS PAGO
    mostrarFrecuencias(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/frecuenciapago`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las frecuencia pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA  FRECUENCIAS PAGO
    crearFrecuencia(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/frecuenciapago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la frecuencia pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ACTUALIZAR FRECUENCIAS PAGO
    editarFrecuencia(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/frecuenciapago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar la frecuencia pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //ELIMINAR FRECUENCIAS PAGO
    eliminarFrecuencias(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/frecuenciapago/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar frecuencia pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS PAGOS AFILIADO
    mostrarPagosAfiliado(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/pagos/0`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    public suscripcionFoto: Subscription = new Subscription();

    //INSERTAR VOUCHER DE PAGO
    insertarRecibo(params: any, validate, callback) {
        this.datosGeneralesFacade.resetearFaceDetail();
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/utils/${environment.processEnv}/v1/repo/`, params, 4).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {

                    if (validate === true) {

                        let datosImagen = result;

                        this.datosGeneralesFacade.validarCargaFoto(`${result.data[0].table0[0].Bucket}/${result.data[0].table0[0].Key}`, data => {
                            if (Number(data.Confidence) >= environment.porcentajeValidezFotos) {
                                callback(datosImagen);
                            }
                        });


                    } else {
                        callback(result);
                    }


                } else {
                    result.errors.forEach(element => {
                        // this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al subir la imagen adjunta', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    guardarArchivoBucket(params: any, validate, callback) {
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/utils/${environment.processEnv}/v1/repo/`, params, 4).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al subir el archivo adjunta', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    // Insertar pago al afiliado
    insertarPagoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagos`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar el pago al afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //MOSTRAS VOUCHER
    mostrarImg64(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/utils/${environment.processEnv}/v1/repo/go504hnrepo/${params}/60/base64`;
        const request$ = this._dataApi.GetDataApi(url, '', 4).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                //   this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //MOSTRAS VOUCHER

    public cargandoVoucher: boolean = false;

    mostrasVoucher(params: any, callback) {
        this.cargandoVoucher = true;
        let url = `${environment.site}/api/utils/${environment.processEnv}/v1/repo/go504hnrepo/${params}/600000`;
        const request$ = this._dataApi.GetDataApi(url, '', 4).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoVoucher = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoVoucher = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                // this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }



    //MOSTRAS BENEFICIARIOS AFILIADO
    mostrarBeneficiariosAfiliado(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/beneficiarios/0`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los beneficiarios', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    // Insertar beneficiario al afiliado
    insertarBeneficiarioAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/beneficiarios`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar el beneficiario', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS parentesco
    mostrarParentesco(params: any, callback) {
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/parentesco`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los parentescos', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS TRABAJOS
    mostrarTrabajos(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/trabajos/${params}`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los trabajos', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA TRABAJO
    insertarTrabajoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Afiliado/trabajos`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar el trabajo', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ELIMINAR CLINICA
    eliminarTrabajo(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/Afiliado/trabajos/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarBeneficiario(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/beneficiarios/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar beneficiarios', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS CLINICAS DEL AFILIADO
    mostrasClinicasAfiliado(params: any, callback) {

        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/clinica/${params}`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las clinicas del afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA CLINICA DEL AFILIADO
    crearClinicaAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/clinica`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                error.error.errors.forEach(element => {
                    this._toast.mensajeError(element.descripcion, '');
                });
                // this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la clinica del afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ELIMINAR CLINICA AFILIADO
    eliminarClinicaAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/clinica/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //MOSTRAS CLINICAS
    mostrarDataTotalAfiliado(params: any, callback) {
        this.cargandoExpediente = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/detalle`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.Parentesco$.next(result.data.table9);
                    this.cargandoExpediente = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoExpediente = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar la informacion del afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS ESTADO CUENTA
    mostrasEstadoCuentaAfiliado(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/estadodecuenta`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {

                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar estado cuenta', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    // NUEVO COBRO
    insertarCobroAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/itemEstadoCuenta`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar la clinica', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS tipos de solicitudes
    mostrarTiposSolicitudes(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las solicitudes', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    // NUEVA tipo de solicitud
    insertarTipoSolicitud(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ELIMINAR 
    eliminarTipoSolicitud(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }




    //MOSTRAS tipos de solicitudes
    mostrarEstadosSolicitudes(params: any, callback) {
        this.cargandoE = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params}/estados`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoE = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoE = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las solicitudes', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS ESTADO
    mostrarEstados(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/estadossolicitudes`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las solicitudes', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    // NUEVA ESTADO
    insertarEstadoASolicitud(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudesestados`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS solcitudes por tipo
    mostrarSolicitudesPorTipo(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params}/solicitudes`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las solicitudes', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }



    // NUEVA ESTADO genral
    insertarEstadoGeneral(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/estadossolicitudes`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }



    //ELIMINAR 
    eliminarEstadoGeneral(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/estadossolicitudes/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    cargarDatos(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/rrhh/${environment.processEnv}/v1/employee/employee/general`;
        const request$ = this._dataApi.GetDataApi(url, '', 6).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    this.cargando = false;

                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los datos generales', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS DETALLES DEL PAGO QUE COBROS PAGO por tipo
    mostrarDetallesPago(params: any, callback) {
        this.cargandoDetallePago = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagos/${params.idPago}/detalle`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoDetallePago = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoDetallePago = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    // NUEVA CONCEPTO PAGO AFILIADO
    insertarConceptoPagoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/conceptospago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarSeguroAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/seguroAfiliado/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }



    eliminarConceptoPagoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/conceptospago/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarCobro(idAfiliado, params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/cobro/${params}`;
        const request$ = this._dataApi.DeleteDataApiUrl(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el cobro', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    anularCobro(idAfiliado, params, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/cobro/cambiarestado`;
        const request$ = this._dataApi.PostDataApi(url, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al anular el cobro', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarArregloPago(idAfiliado, params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/arreglopago/${params.id}`;
        const request$ = this._dataApi.DeleteDataApi(url, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el cobro', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS PROGRAMAS
    mostrarProgramas(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarProgramas(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarPrograma(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //MOSTRAS PROMOCIONES PROGRAMAS
    mostrarPromocionesProgramas(params: any, callback) {
        this.cargandoP = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params}/promociones`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.data.hasError) {
                    callback(result);
                    this.cargandoP = false;
                } else {
                    result.data.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoP = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarPromocionProgramas(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    actualizarPromocionProgramas(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    eliminarPromocionPrograma(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones/${params.idPromocionPrograma}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //MOSTRAS PEROSNAS PROMOCIONES PROGRAMAS
    mostrarPersonaPromocionesProgramas(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/promocionesprogramas/`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarPersonaPromocionProgramas(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones/${params.idPromocion}/personas`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarPersonaPromocionPrograma(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones/${params.idPromocion}/personas/${params.id}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    updateInfoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/datospersonales/actualizar`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //MOSTRAS PEROSNAS PROMOCIONES PROGRAMAS
    mostrarEstadoPromocionesProgramas(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/estados/promocionesprogramas/`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarInfoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/registro`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, error.error.errors[0].descripcion, '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    cambiarEstadoSolicitud(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/solicitudes/${params.idTipoSolicitud}/${params.idSolicitud}`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();

                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al cambiar estado de la solicitud', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    nuevoAfiliadoCompleto(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/nuevo`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts()

                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar el expediente', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarRequisitosAfiliado(params: any, callback) {
        this.cargandoR = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/requisitos`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoR = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoR = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarRequisitoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/requisitos`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    eliminarRequisitoAfiliado(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/requisitos/${params.idRequisitoExpediente}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    mostrarRequisitos(params: any, callback) {
        this.cargandoR = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/requisitos`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoR = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoR = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarRequisito(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/requisitos`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarRequisito(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/requisitos/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    mostrarFirmas(params: any, callback) {
        this.cargandoF = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params}/firmas`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoF = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoF = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    insertarFirma(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params.idTipoSolicitud}/tipoSolicitudFirmas`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    eliminarFirma(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tipossolicitudes/${params.idTipoSolicitud}/firmas/${params.idTipoSolicitudFirma}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    imprimirSolicitud(params: any, callback) {
        this.cargandoPrint = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/solicitudes/${params.idTipoSolicitud}/${params.idSolicitud}/imprimir`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoPrint = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoPrint = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al imprimir', '');
                this.router.navigate(['/affiliates/listaAfiliados']);
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarFecha(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/utils/${environment.processEnv}/v1/fecha`;
        const request$ = this._dataApi.GetDataApi(url, '', 4).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar fecha', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    validarEstadoCuenta(params: any, callback) {
        this.cargandoPrint = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params}/validarestadodecuenta`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoPrint = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoPrint = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarSolicitud(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/solicitudes`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    crearFactura(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/factura/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al crear la factura', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    imprimirFactura(params: any, callback) {
        this.cargandoPrint = true;
        let url = `${environment.site}/api/sales/${environment.processEnv}/v1/ventas/rptImprimirFactura/${params}`;
        const request$ = this._dataApi.GetDataApi(url, '', 2).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoPrint = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoPrint = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    formasGeneralesdePago(idOpcionPago: any, callback) {

        this.cargandoPrint = true;
        let url = `${environment.site}/api/purchase/${environment.processEnv}/v1/purchaseBill/paymentMethods/1/4`;
        const request$ = this._dataApi.GetDataApi(url, '', 3).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargandoPrint = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargandoPrint = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    reenvioCorreo(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/registro/reiniciarclave`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts()
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    mostrarTiposAfiliacion(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/tiposafiliacion`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar tipos afiliación', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //Medios de Pago
    mostrarMedioPago(idAfiliado: any, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/tarjeta`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar el medio de pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarMedioPago(params: any, callback) {
        this.cargando = true;
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/tarjeta`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar el medio de pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarMedioPago(idAfiliado, params: any, callback) {
        this.cargando = true;
        const request$ = this._dataApi.DeleteDataApiUrl(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/tarjeta/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el medio de pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    guardarArchivo(parametros: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/archivotransacciones`, parametros, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al guardar archivo', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    procesarArchivo(parametros: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/archivotransacciones/procesar`, parametros, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al procesar el archivo', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    mostrarProductos(params?: any) {
        this.Cargando$.next(true);
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/admin/${environment.processEnv}/v1/product/search/`, params, 1).pipe(
            tap((result: DataApi | any) => {
                if (result.hasError === false) {
                    this.Productos$.next(result.data.table0);
                    this.ProductosDetalles$.next(result.data.table1[0]);
                }
                this.Cargando$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los productos', '');
                this.Cargando$.next(false);
                return EMPTY;
            })
        );
        return request$.subscribe();
    }


    //Arreglo pago
    mostrarPagosMora(params?: any) {
        this.PagoMora$.next([]);
        this.Cargando$.next(true);
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagospendientes`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (result.hasError === false) {
                    this.PagoMora$.next(result.data.table0);
                }
                this.Cargando$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los pagos en mora', '');
                this.Cargando$.next(false);
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarArregloPago(params?: any) {
        this.Cargando$.next(true);
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/arreglopago`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (result.hasError === false) {
                    this.ArregloPago$.next(result.data.table0);
                }
                this.Cargando$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los arreglos de pago', '');
                this.Cargando$.next(false);
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    resetPagosMora() {
        this.PagoMora$.next([]);
    }

    private Action$ = new BehaviorSubject<any>({});
    public responseAction$: Observable<any> = this.Action$.asObservable();

    private ArregloPago$ = new BehaviorSubject<any[]>([]);
    public responseArregloPago$: Observable<any[]> = this.ArregloPago$.asObservable();

    insertarArregloPago(params: any) {
        this.Action$.next({});
        this.Cargando$.next(true);
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/arreglopago`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (result.hasError === false) {
                    this.Action$.next(result);
                    this._toast.mensajeSuccess('Se creo con exito el arreglo de pago', '');
                }

                this.Cargando$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this.Action$.next({});
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al crear el arreglo de pago', '');
                this.Cargando$.next(false);
                return EMPTY;
            })
        );

        return request$.subscribe();
    }

    private DetalleArregloPago$ = new BehaviorSubject<DetalleArregloPagoInterface>({});
    public responseDetalleArregloPago$: Observable<DetalleArregloPagoInterface> = this.DetalleArregloPago$.asObservable();

    mostrarDetalleArregloPago(params?: any) {
        this.Cargando$.next(true);
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/arreglopago/`, params.idArregloPago, 8).pipe(
            tap((result: DataApi | any) => {
                if (result.hasError === false) {
                    this.DetalleArregloPago$.next(result.data);
                }
                this.Cargando$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar el detalle del arreglo de pago', '');
                this.Cargando$.next(false);
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrasPagosAnulados(params: any, callback) {
        this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagoseliminados/`, params.idPago, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los pagos anulados', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarPago(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');

        const request$ = this._dataApi.DeleteDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagos/${params.idPago}`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    actualizarPago(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagos/${params.idPago}/detalle`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    this._toast.mensajeSuccess('El pago se actualizo de manera exitosa', '');
                    callback(result.data.table0);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar el pago', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarDatosCarnet(params: any, callback) {
        this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Carnet/${params.idAfiliado}/${params.idTipoExpediente}`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    this.cargando = false;
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los datos del carnet', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    insertarBeneficiarioCarnet(params: any, callback) {
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Carnet/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar los datos del beneficiario', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    actualizarBeneficiarioCarnet(params: any, callback) {
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/Carnet/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar los datos del beneficiario', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //UDH
    mostrarCategoriaBeneficiario(callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/generales/categoriabeneficiario`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las categorias del beneficiario', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarInstitucionesMilitares(callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/generales/institucionmilitar`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las instituciones militares', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarTipoInstitucionesMilitares(idInstitucionMilitar, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/generales/tipoinstitucionmilitar/${idInstitucionMilitar}/rangosmilitares`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las instituciones militares', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarRangoMilitares(idInstitucionMilitar, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/${idInstitucionMilitar}/rangosmilitares`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las instituciones militares', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarMediosComunicacion(callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/generales/mediocomunicacion`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los medios de comunicación', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarPromocionDetalleCobro(params, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/programaseducacion/${params.idPrograma}/promociones/${params.idPromocionPrograma}/detallecobros`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los medios de comunicación', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarPromocionesAfiliado(params, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/promocionesprogramas`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las promociones del afiliado', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarEstadoCuentaProgramaAfiliado(params, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/promocion/${params.idPromocion}/estadocuenta`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar el estado de cuenta por promocion', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarMoraValidacion(params, callback) {
        // this.cargando = true;
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagospendientes`, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result.data.table0);
                    // this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        // this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    actualizarBucketImpresion(params: any, callback) {
        // this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/solicitudes/impresion/${params.idImpresion}/bucket`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    validarDocumento(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/solicitudes/impresion/validar`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    generarPassword(params: any, callback){
        this.Cargando$.next(true);
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/registro/reiniciarclaveGenerada`, params, 8).pipe(
          tap((result: DataApi | any) => {
            this._toast.mensajeSuccess('Se genero la contraseña con éxito', '');
            callback(result);
            this.Cargando$.next(false);
          }),
          catchError((error: HttpErrorResponse) => {
            callback();
            this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al insertar el afiliado', '');
            this.Cargando$.next(false);
            
            return EMPTY;
          })
        );
    
        return request$.subscribe();
      }

    getLaboratorios(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    getLaboratoriosById(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios/${params}`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrarRequisitosLaboratorio(idLaboratorio: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios/requisitos/${idLaboratorio}`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los requisitos', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    guardarRequisitoLaboratorio(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios/requisito/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._toast.clearToasts();
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al guardar el requisito', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    // NUEVA CLINICA
    postLaboratorio(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts()
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al ingresar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    //ACTUALIZAR CLINICA
    putLaboratorio(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios`, params, 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
    //ELIMINAR CLINICA
    deleteLaboratorio(params: any, callback) {
        this._toast.mensajeLoading('Cargando', 'Procesando la información');


        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios/${params}`;
        const request$ = this._dataApi.DeleteDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                this._toast.clearToasts();
                if (!result.hasError) {
                    callback(result);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar clinicas', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    getCombox(params: any, callback) {
        this.cargando = true;
        let url = `${environment.site}/api/afiliados/${environment.processEnv}/v1/laboratorios/generales`;
        const request$ = this._dataApi.GetDataApi(url, '', 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.cargando = false;
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.cargando = false;
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    mostrasConceptosPagoCuentaContable(params: any, callback) {
        this.CargandoCuentasContable$.next(true);
        const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago/cuentaContable/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.CargandoCuentasContable$.next(false);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.CargandoCuentasContable$.next(false);
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar las cuentas contables', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    guardarConceptosPagoCuentaContable(params: any, callback) {
        this.CargandoCuentasContable$.next(true);
        const request$ = this._dataApi.PostDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago/cuentaContable/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.CargandoCuentasContable$.next(false);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.CargandoCuentasContable$.next(false);
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al guardar la cuentas contable', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    actualizarConceptosPagoCuentaContable(params: any, callback) {
        this.CargandoCuentasContable$.next(true);
        const request$ = this._dataApi.PutDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago/cuentaContable/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.CargandoCuentasContable$.next(false);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.CargandoCuentasContable$.next(false);
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar la cuentas contable', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }

    eliminarConceptosPagoCuentaContable(params: any, callback) {
        this.CargandoCuentasContable$.next(true);
        const request$ = this._dataApi.DeleteDataApiUrl(`${environment.site}/api/afiliados/${environment.processEnv}/v1/conceptospago/cuentaContable/`, params, 8).pipe(
            tap((result: DataApi | any) => {
                if (!result.hasError) {
                    callback(result);
                    this.CargandoCuentasContable$.next(false);
                } else {
                    result.errors.forEach(element => {
                        this._toast.mensajeInfo(element.descripcion, '');
                        this.CargandoCuentasContable$.next(false);
                    });
                    callback();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar la cuentas contable', '');
                return EMPTY;
            })
        );
        return request$.subscribe();
    }
}